import { slugify } from "../../../utils/string";

const filterBehaviour = (
  filteredData,
  filterState,
  filterKeys,
  setFilteredEntities,
  searchState
) => {
  //------------- Check if state is not empty so the filter doesn't trigger
  const isStateFilled = () => {
    for (const key in filterState) {
      if (filterState[key].length > 0) {
        return true;
      }
    }
    return false;
  };

  if (isStateFilled()) {
    let tempFilteredData = [];

    //----Construction du tableau de tableau d'entité(s) qui correspond(ent) aux filtres sélectionnés
    for (const key in filterState) {
      if (filterState[key].length > 0) {
        tempFilteredData = [
          ...tempFilteredData,
          filteredData.filter((entity) =>
            entity[key].some((item) => filterState[key].includes(item))
          ),
        ];
      }
    }

    //--- Filter entity depending on the selected filters, flat the data and only keep the entities that are in all tempFiltederData subArray
    if (tempFilteredData.length > 1) {
      let flatData = tempFilteredData.flat();
      let necklaceFilteredData = [];
      for (const data of flatData) {
        let tempArray = flatData.filter((elt) => data.id === elt.id);
        if (
          tempArray.length === tempFilteredData.length &&
          !necklaceFilteredData.find((element) => element.id === data.id)
        ) {
          necklaceFilteredData.push(data);
        }
      }
      if (searchState) {
        let tempArray = [];
        for (const data of necklaceFilteredData) {
          if (slugify(data.name).includes(slugify(searchState))) {
            tempArray.push(data);
          }
        }
        setFilteredEntities(tempArray);
      } else {
        setFilteredEntities(necklaceFilteredData);
      }

      return null;
    } else {
      let tempArray = [];
      let flatData = tempFilteredData.flat();
      if (searchState) {
        for (const data of flatData) {
          if (slugify(data.name).includes(slugify(searchState))) {
            tempArray.push(data);
          }
        }
        setFilteredEntities(tempArray);
      } else {
        setFilteredEntities(flatData);
      }
      return null;
    }
  } else {
    let tempArray = [];
    if (searchState) {
      for (const data of filteredData) {
        if (slugify(data.name).includes(slugify(searchState))) {
          tempArray.push(data);
        }
      }
      setFilteredEntities(tempArray);
    } else {
      setFilteredEntities(filteredData);
    }
    return null;
  }
};

export default filterBehaviour;
